import React, { Fragment } from 'react';
import styled from 'styled-components';

import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import { toFriendlyDateTimeString } from 'helpers/Formatter';
import { colors } from 'helpers/ColorHelper';

const StyledPostedCommentContainer = styled.div`
  margin-top: 15px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${colors.LIGHT_PERIWINKLE};
  background: white;
`;

const StyledPostedCommentDetailsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 7px 0px;
  align-items: center;
`;

const StyledAuthor = styled.p`
  font-weight: 800;
  margin: 0px;
`;

const StyledSentOn = styled.div`
  color: ${colors.FONT_GRAY};
`;

const CommentCard = ({ comment }) => {
  return (
    <Fragment>
      <StyledPostedCommentContainer>
        <StyledPostedCommentDetailsContainer>
          <StyledAuthor>{comment.author}</StyledAuthor>
          <StyledSentOn>
            {getTranslatedString('landlordPortal.internalComments.sentOn', {
              date: toFriendlyDateTimeString(comment.time, {
                language: getCurrentLocale(),
              }),
            })}
          </StyledSentOn>
        </StyledPostedCommentDetailsContainer>
        <div>{comment.verbiage[0]}</div>
      </StyledPostedCommentContainer>
    </Fragment>
  );
};

export default CommentCard;
